<template>
  <div class="product-banner">
    <img :src="mobileproductBanner" alt="" />
    <div class="absolute">
      <div class="title">产品中心</div>
      <div class="text">
        科技创造智慧生活，软硬一体化打通线上线下
        ，全场景业务监管，赋能物业居委，三端协同，数据同步，让物业办事更有效率。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience v-if="experienceShow" :experienceShow="experienceShow" @experienceClick="experienceClick"></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from '../../../components/mobile/components/Experience.vue'

import mobileproductBanner from "../../../assets/product/mobileproductBanner.png";

export default {
  setup() {
    return reactive({
      mobileproductBanner: mobileproductBanner,
      experienceShow: false
    });
  },
  components: {
    Experience
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow
    }
  },
};
</script>

<style scoped>
.product-banner {
  position: relative;
}
.product-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #248EFB;
}
.absolute .text {
  font-size: 12px;
  margin-top: 12px;
  color: #248EFB;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 5px;
  color: #248EFB;
  border: 1px solid rgba(36, 142, 251, .8);
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
